module.exports = __webpack_public_path__ + "static/media/IndustryUpdatePre_2020.a93736ac.png";